var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_219_4260",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.704346,
    y: 0.565735,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_219_4260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3043 17.1657L18.3543 10.1157L16.9543 8.71573L11.3043 14.3657L8.45435 11.5157L7.05435 12.9157L11.3043 17.1657ZM12.7043 22.5657C11.321 22.5657 10.021 22.3032 8.80435 21.7782C7.58768 21.2532 6.52935 20.5407 5.62935 19.6407C4.72935 18.7407 4.01685 17.6824 3.49185 16.4657C2.96685 15.2491 2.70435 13.9491 2.70435 12.5657C2.70435 11.1824 2.96685 9.8824 3.49185 8.66573C4.01685 7.44907 4.72935 6.39073 5.62935 5.49073C6.52935 4.59073 7.58768 3.87823 8.80435 3.35323C10.021 2.82823 11.321 2.56573 12.7043 2.56573C14.0877 2.56573 15.3877 2.82823 16.6043 3.35323C17.821 3.87823 18.8793 4.59073 19.7793 5.49073C20.6793 6.39073 21.3918 7.44907 21.9168 8.66573C22.4418 9.8824 22.7043 11.1824 22.7043 12.5657C22.7043 13.9491 22.4418 15.2491 21.9168 16.4657C21.3918 17.6824 20.6793 18.7407 19.7793 19.6407C18.8793 20.5407 17.821 21.2532 16.6043 21.7782C15.3877 22.3032 14.0877 22.5657 12.7043 22.5657Z",
    fill: "#028102"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/Verified.57eb575633a3a9fef0a34482f214298c.svg";
export { ForwardRef as ReactComponent };